import Head from 'next/head';
import useTranslation from 'next-translate/useTranslation';
import { useRouter } from 'next/router';

export default function Meta({
  title,
  description,
  fbShareThumb,
}: {
  title?: string | null;
  description?: string | null;
  fbShareThumb?: string | null;
}) {
  const { t } = useTranslation('common');
  const { asPath } = useRouter();

  const canonicalUrl = `https://exam.flyer.us${asPath}`;
  const prefixMatchPaths = [
    '/testlevels',
    '/check-point',
    '/libraries',
    '/login',
    '/recover',
    '/signup',
    '/flyer-package',
    '/practice-words',
    '/mission',
    '/my-school',
    '/history',
  ];
  const isMatched = prefixMatchPaths.some((path) => asPath.startsWith(path));

  if (isMatched && !title && !description) {
    return null;
  }

  return (
    <Head>
      <title>{title || t('head.default_page_title')}</title>
      <link rel="canonical" href={canonicalUrl} />
      <meta name="robots" content="index,follow" />
      <meta name="description" content={description || t('head.default_page_description')} />

      {/* google */}
      <meta itemProp="name" content={title || t('head.default_page_title')} />
      <meta itemProp="description" content={description || t('head.default_page_description')} />

      {/* facebook */}
      <meta
        property="og:title"
        content={title || t('head.default_page_title')}
        itemProp={title ? 'title' : undefined}
      />
      <meta
        property="og:description"
        content={description || t('head.default_page_description')}
        itemProp={description ? 'description' : undefined}
      />
      <meta
        property="og:image"
        content={fbShareThumb || '/media/images/thumbnail-home.png'}
        itemProp={fbShareThumb ? 'image' : undefined}
        key={fbShareThumb ? 'og:image' : undefined}
      />
      <meta property="og:type" content="website" />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title || t('head.default_page_title')} />
      <meta
        name="twitter:description"
        content={description || t('head.default_page_description')}
      />
      <meta name="twitter:image" content={fbShareThumb || '/media/images/thumbnail-home.png'} />
    </Head>
  );
}
